import type { TemplateConfig } from '../../types/templates';
import {
  disneyAvailableNow,
  disneyCTV,
  disneySeasonality,
  disneySocialThisMonth,
  disneyRelated,
  disneySocialTop,
  disneyCast,
  disneyGrid,
  disneyBinge,
  disneyBestPlan,
  disneyEspnVS,
  disneyEspnPlayerVSPlayer,
  disneyEspnHero,
  disneyESPNTextuales,
  disneyESPNLogoVsLogo
} from '../DISNEY/';

import { resumidoCarouselGenerico, resumidoCarouselManoAMano } from '../RESUMIDO';

import { GPOVALLASAutoResolution, GPOVALLASAutoResolutionBranded } from '../GPOVALLAS';

import {
  macroAhorro,
  macroCuotas,
  macroCTV,
  macroGIF,
  macroSacaTuTarjeta,
  macroSelecta,
  macroSelectaGlass
} from '../MACRO';
import { macroBeneficios } from '../MACRO/beneficios';
import { hipotecarioBeneficios, hipotecarioCTV } from '../HIPOTECARIO';
import { macroAhorroDoble } from '../MACRO/ahorro-doble';

export const TEST_TEMPLATES: TemplateConfig[] = [
  // Hipotecario
  { ...hipotecarioBeneficios, clientId: 'TEST', handlerKey: 'HIPOTECARIO' },
  { ...hipotecarioCTV, clientId: 'TEST', handlerKey: 'HIPOTECARIO' },

  // Macro templates (all migrated — use handlerKey)
  { ...macroSelecta, clientId: 'TEST', handlerKey: 'MACRO' },
  { ...macroSelectaGlass, clientId: 'TEST', handlerKey: 'MACRO' },
  { ...macroAhorro, clientId: 'TEST', handlerKey: 'MACRO' },
  { ...macroAhorroDoble, clientId: 'TEST', handlerKey: 'MACRO' },

  { ...macroBeneficios, clientId: 'TEST', handlerKey: 'MACRO' },
  { ...macroCuotas, clientId: 'TEST', handlerKey: 'MACRO' },
  { ...macroCTV, clientId: 'TEST', handlerKey: 'MACRO' },
  { ...macroGIF, clientId: 'TEST', handlerKey: 'MACRO' },
  { ...macroSacaTuTarjeta, clientId: 'TEST', handlerKey: 'MACRO' },

  // Resumido templates (not migrated)
  { ...resumidoCarouselGenerico, clientId: 'TEST', handlerKey: 'RESUMIDO' },
  { ...resumidoCarouselManoAMano, clientId: 'TEST', handlerKey: 'RESUMIDO' },

  // GPO Vallas templates (not migrated)
  { ...GPOVALLASAutoResolution, clientId: 'TEST', handlerKey: 'GPOVALLAS' },
  { ...GPOVALLASAutoResolutionBranded, clientId: 'TEST', handlerKey: 'GPOVALLAS' },

  // Disney templates (all migrated — use handlerKey)
  { ...disneyESPNLogoVsLogo, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneyESPNTextuales, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneyEspnHero, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneyCTV, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneyAvailableNow, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneySeasonality, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneyEspnVS, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneyEspnPlayerVSPlayer, clientId: 'TEST', handlerKey: 'DISNEY' },

  // Disney proximamente (disabled, kept in TEST for visual reference)
  { ...disneySocialThisMonth, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneyRelated, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneySocialTop, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneyCast, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneyGrid, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneyBinge, clientId: 'TEST', handlerKey: 'DISNEY' },
  { ...disneyBestPlan, clientId: 'TEST', handlerKey: 'DISNEY' }
];
